module.exports = __webpack_public_path__ + "img/MEDIA074.4cae01ea.jpg";